import { useGetCurrentUserQuery } from 'services';
import { BillingPlan } from 'shared/models';

export const useIsFree = () => {
	const { data } = useGetCurrentUserQuery();

	return data && data.billing_plan === BillingPlan.FREE;
};
